// =========
//   Rule
// =========

function Rule(caption, condition, isEnabled) {
    this.caption = caption;
    this.condition = condition;
    this.isEnabled = isEnabled;
    this.actions = [];
}

Rule.prototype.printRule = function () {
    var printStr = this.condition + ' || ' + this.isEnabled;
    return printStr;
};

Rule.prototype.getActions = function () {
    return this.actions;
};

Rule.prototype.addAction = function (action) {
    this.actions.push(action);
};

export default Rule;
